import { useCallback } from 'react';
import { AuditService } from '@/services/audit.service';

export const useAuditLog = () => {
  const logChange = useCallback(async (
    changedBy: string,
    changedProperty: string,
    changedFrom: string | null,
    changedTo: string | null
  ) => {
    try {
      await AuditService.logChange({
        changed_by: changedBy,
        changed_property: changedProperty,
        changed_from: changedFrom,
        changed_to: changedTo
      });
    } catch (error) {
      console.error('Failed to log change:', error);
      // You might want to handle this error differently in production
      throw error;
    }
  }, []);

  return { logChange };
}; 